
















































































import Vue, { PropType } from "vue";
import "@/components/icons";
import Overlay from "@/components/Atoms/Overlay/index.vue";
import FloatingView from "@/components/Atoms/FloatingView/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import CustomButton from "@/components/Atoms/Button/index.vue";
import LoadingIcon from "@/components/Atoms/LoadingIcon/index.vue";
import Checkbox from "@/components/Atoms/Forms/Checkbox/index.vue";
import {
  addFollowCompanies,
  getFollowCompanies as getFollowCompaniesRequest
} from "@/api";
import { ApiResponse } from "@/api/types";

export interface Data {
  checkedCompanies: Application.Company[];
  followedCompanies: ApiResponse.CompanyWithLikeCount[];
  loading: {
    fetchingFollowedCompanies: boolean;
    addingCompanies: boolean;
  };
}

export interface Computed {
  disabledSubmitButton: boolean;
  selectedAll: boolean;
  fillterdCompanies: Props["companies"];
}

export interface Props {
  companies: Application.Company[];
}

export interface Methods {
  getFollowCompanies: () => void;
  handleClickSubmit: () => void;
  onClickSelectAll: (chceckedVakues: boolean[]) => void;
  onCheckCompany: (
    chceckedVakues: boolean[],
    company: Application.Company
  ) => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "FollowCompetitorFloatingView",
  components: {
    Overlay,
    FloatingView,
    Heading,
    CustomButton,
    LoadingIcon,
    Checkbox
  },
  props: {
    companies: {
      type: Array as PropType<Props["companies"]>,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      checkedCompanies: [],
      followedCompanies: [],
      loading: {
        fetchingFollowedCompanies: false,
        addingCompanies: false
      }
    };
  },
  computed: {
    disabledSubmitButton() {
      return !this.checkedCompanies.length;
    },
    fillterdCompanies() {
      return this.companies.filter(
        company =>
          !this.followedCompanies.some(
            followedCompany => followedCompany.id === company.id
          )
      );
    },
    selectedAll() {
      return this.companies.length === this.checkedCompanies.length;
    }
  },
  mounted() {
    this.getFollowCompanies();
  },
  methods: {
    async getFollowCompanies() {
      try {
        this.$set(this.loading, "fetchingFollowedCompanies", true);
        const { data } = await getFollowCompaniesRequest();
        this.followedCompanies = data.companies;
      } finally {
        this.$set(this.loading, "fetchingFollowedCompanies", false);
      }
    },
    async handleClickSubmit() {
      try {
        this.$set(this.loading, "addingCompanies", true);
        await addFollowCompanies({
          company_ids: this.checkedCompanies.map(campany => campany.id)
        });
      } finally {
        this.$set(this.loading, "addingCompanies", false);
      }

      this.$emit("close");
    },
    onCheckCompany(chceckedVakues, company) {
      if (chceckedVakues[0]) {
        this.checkedCompanies = [...this.checkedCompanies, company];
      } else {
        this.checkedCompanies = this.checkedCompanies.filter(
          checkedCompany => checkedCompany.id !== company.id
        );
      }
    },
    onClickSelectAll(chceckedVakues) {
      if (chceckedVakues[0]) {
        this.checkedCompanies = this.companies;
      } else {
        this.checkedCompanies = [];
      }
    }
  }
});
